import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer, referralAccountSettingsFeatureKey } from './referral-account-settings.reducer';
import { ReferralAccountSettingsEffects } from './referral-account-settings.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(referralAccountSettingsFeatureKey, reducer),
    EffectsModule.forFeature([ReferralAccountSettingsEffects])
  ]
})
export class ReferralAccountSettingsStoreModule {}
